class Play {
	constructor(rkey, app, name, wsUrl, isdisplay, isaudio, callback, palyid) {
		this.rkey = rkey
		this.app = app
		this.name = name
		this.palyid = palyid
		this.isdisplay = isdisplay
		this.isaudio = isaudio
		this.peerConnectionConfig = {
			iceServers: []
		}
		this.RTCPeerConnection = null
		this.returnApp = ''
		this.returnStream = ''
		this.returnPlayid = ''
		this.returnSdp = ''
		this.reconnectionNum = 0
		this.video = null
		this.videos = null
		this.createAnswer = this.createAnswer.bind(this)
		this.gotRemoteStream = this.gotRemoteStream.bind(this)
		this.setRemoteDescription = this.setRemoteDescription.bind(this)
		this.gotDescription = this.gotDescription.bind(this)
		this.playReturn = this.playReturn.bind(this)
		this.audioDelayFun = this.audioDelayFun.bind(this)
		this.stream = null
		this.delay = 0
		this.newStream = new MediaStream()
		this.audioCtx = new AudioContext()
		this.delayNode = null
		this.wsUrl = wsUrl
		this.wsConnectionPlay = null
		this.alive = null
		this.heartbeatPlay = this.heartbeatPlay.bind(this)
		this.wsConnectPlay = this.wsConnectPlay.bind(this)
		this.getAvailableStreams = this.getAvailableStreams.bind(this)
		/* 0 未播放 1 播放成功 2 播放失败 3 停止播放 */
		this.play_state = 0
		this.video_width = 0
		this.video_height = 0
		this.callback = callback
		this.isAudioDelayFun = 0
	}
	set(returnApp, returnStream, returnPlayid, returnSdp) {
		this.returnApp = returnApp
		this.returnStream = returnStream
		this.returnPlayid = returnPlayid
		this.returnSdp = returnSdp
	}
	createAnswer() {
		this.RTCPeerConnection.createAnswer(this.gotDescription, this.errorHandler)
	}
	getAvailableStreams() {
		this.RTCPeerConnection = new RTCPeerConnection(this.peerConnectionConfig)
		this.RTCPeerConnection.onicecandidate = this.gotIceCandidate_play
		this.RTCPeerConnection.onaddstream = this.gotRemoteStream
		this.wsConnectionPlay.send('{"cmd":"play", "app":"' + this.app + '", "stream":"' + this.rkey + '"}')
	}

	Callbacks(e, id, val) {
		this.callback(e, id, val)
	}

	audioDelayFun(type) {
		var video = document.getElementById(this.palyid)
		if (type == 'openaudiodelay') {
			video.muted = true
			this.recvAudioSources.connect(this.delayNode)
			this.delayNode.connect(this.audioCtx.destination)
		} else if (type == 'closeaudiodelay') {
			video.muted = false
			this.recvAudioSources.disconnect(this.delayNode)
			this.delayNode.disconnect(this.audioCtx.destination)
		}
	}

	gotRemoteStream(event) {
		this.video = document.getElementById(this.palyid)
		if (!this.video) {
			var x = document.createElement('VIDEO')
			x.setAttribute('autoplay', true)
			x.setAttribute('controls', '')
			x.setAttribute('style', 'controls')
			x.setAttribute('id', this.palyid)
			if (!this.isdisplay) {
				x.setAttribute('style', 'display:none')
			}
			x.setAttribute('muted', '')
			document.body.appendChild(x)
			// var video_html = '<video  id="'+this.rkey+'"  autoplay=true  controls="" style="display:none"></video>'//style="display:none"
			// document.getElementById("videos_con").appendChild(video_html)
		}
		this.stream = event.stream
		this.video = document.getElementById(this.palyid)
		this.video.srcObject = this.stream
		this.videos = document.getElementById(this.palyid)
		this.video.play()
		var curObj = this
		this.video.addEventListener('canplay', function (e) {
			curObj.video_width = e.target.videoWidth
			curObj.video_height = e.target.videoHeight
			// console.log(e.target.videoWidth)
			// console.log(e.target.videoHeight)
			curObj.Callbacks(2, null, null)
		})
		// if (false) {
		// 	var audioContext = new AudioContext()
		// 	this.audioCtx = new AudioContext()
		// 	var audioTrack_media = this.stream.getAudioTracks()[0]
		// 	this.newStream = new MediaStream()
		// 	this.newStream.addTrack(audioTrack_media)
		// 	this.recvAudioSources = this.audioCtx.createMediaStreamSource(this.newStream)
		// 	this.delayNode = new DelayNode(this.audioCtx, {
		// 		delayTime: 0.1,
		// 		maxDelayTime: 2,
		// 	})
		// 	var mediaStreamSource = audioContext.createMediaStreamSource(this.newStream)
		// 	// 创建一个音频分析对象，采样的缓冲区大小为4096，输入和输出都是单声道
		// 	var scriptProcessor = audioContext.createScriptProcessor(4096, 1, 1)
		// 	// 将该分析对象与麦克风音频进行连接
		// 	mediaStreamSource.connect(scriptProcessor)
		// 	// 此举无甚效果，仅仅是因为解决 Chrome 自身的 bug
		// 	scriptProcessor.connect(audioContext.destination)
		// 	// 开始处理音频
		// 	var rkey = this.rkey
		// 	var curObj = this
		// 	scriptProcessor.onaudioprocess = function (e) {
		// 		// var video = document.getElementById(rkey)
		// 		// console.log(video.muted)
		// 		// 获得缓冲区的输入音频，转换为包含了PCM通道数据的32位浮点数组
		// 		let buffer = e.inputBuffer.getChannelData(0)
		// 		// 获取缓冲区中最大的音量值
		// 		let maxVal = Math.max.apply(Math, buffer)
		// 		// 显示音量值
		// 		// console.log(maxVal * 100)
		// 		//console.log(maxVal * 100)
		// 		var roundnum = maxVal * 100 //Math.round(maxVal * 100)
		// 		if (curObj.isAudioDelayFun == 1) {
		// 			curObj.Callbacks(1, rkey, Math.round(maxVal * 100))
		// 		}
		// 		// window[rkey+"_delay"] = Math.round(maxVal * 100)
		// 		// // console.log(window.self_des_audio_track)
		// 		// // window.self_audio.getTracks().forEach(
		// 		// //     track => {
		// 		// //         track.enabled = false
		// 		// //     }
		// 		// // )
		// 		// if (window.self_des_audio_track != null) {
		// 		//     if (roundnum > 1){
		// 		//         //console.log(Date.now())
		// 		//         if (window.self_des_audio_track.enabled == true) {
		// 		//             window.self_des_audio_track.enabled = false
		// 		//         }
		// 		//         //console.log(Date.now())
		// 		//     }else{
		// 		//         if (window.self_des_audio_track.enabled == false) {
		// 		//             setTimeout(function () {
		// 		//                 if(window[rkey+"_delay"] < 1){
		// 		//                     window.self_des_audio_track.enabled = true
		// 		//                 }
		// 		//             },200)
		// 		//         }
		// 		//     }
		// 		//
		// 		//     //}
		// 		// }
		// 	}
		// }
	}
	gotIceCandidatePlay() {

	}
	setRemoteDescription(sdp) {
		this.RTCPeerConnection.setRemoteDescription(new RTCSessionDescription(sdp), this.createAnswer, this
			.errorHandler)
	}
	gotDescription(description) {
		this.RTCPeerConnection.setLocalDescription(
			description,
			this.playReturn,
			function () {
			}
		)
	}
	playReturn() {
		this.wsConnectionPlay.send(
			'{"cmd":"play_return", "app":"' +
			this.returnApp +
			'", "stream":"' +
			this.returnStream +
			'", "sessionid":"' +
			this.returnPlayid +
			'", "sdp":' +
			this.returnSdp +
			'}'
		)
	}
	errorHandler(error) {
		console.log(error)
	}

	/**
	 * webscket
	 */
	wsConnectPlay() {
		this.wsConnectionPlay = new WebSocket(this.wsUrl)
		this.wsConnectionPlay.binaryType = 'arraybuffer'
		/* 链接webrtc */
		var curObj = this
		this.wsConnectionPlay.onopen = function () {
			this.alive = setTimeout(function () {
				curObj.heartbeatPlay()
			}, 1000 * 3)
			curObj.getAvailableStreams()
		}
		/* 返回消息 */
		this.wsConnectionPlay.onmessage = function (evt) {
			console.log('wsConnectionPlay======', JSON.stringify(evt))
			var msgJSON = JSON.parse(evt.data)
			var msgStatus = Number(msgJSON['status'])
			// var msgCommand = msgJSON['command']
			if (msgJSON['cmd'] == 'play') {
				if (msgStatus == 200) {
					let sdpData = msgJSON['sdp']
					if (sdpData !== undefined) {
						curObj.set(msgJSON['app'], msgJSON['stream'], msgJSON['playid'], JSON.stringify(msgJSON['sdp']))
						curObj.setRemoteDescription(msgJSON.sdp)
					}
				} else {
					/* if(window.reconnection_num > curObj.reconnection_num){ */
					curObj.reconnectionNum = curObj.reconnectionNum + 1
					setTimeout(function () {
						curObj.RTCPeerConnection.close()
						/* curObj.RTCPeerConnection.dispose() */
						curObj.RTCPeerConnection = null
						curObj.getAvailableStreams()
					}, 2000)
					/* } */
				}
			}
			if (msgJSON['cmd'] == 'notify') {
				if (msgJSON['event'] == 'playclosed') {
					curObj.getAvailableStreams()
				}
			}
			if (msgJSON['cmd'] == 'play_return') {

			}

			if (msgJSON['cmd'] == 'alive') {
				this.alive = setTimeout(function () {
					curObj.heartbeatPlay()
				}, 7000)
			}
		}
		this.wsConnectionPlay.onerror = function (evt) {
		}
		this.wsConnectionPlay.onclose = function () {
			curObj.wsConnectionPlay = null
			if (curObj.play_state != 3) {
				setTimeout(function () {
					curObj.wsConnectPlay()
				}, 5000)
			}
		}
	}

	heartbeatPlay() {
		clearTimeout(this.alive)
		this.wsConnectionPlay.send('{"cmd":"alive"}')
	}

	stopPlay() {
		this.play_state = 3
		this.wsConnectionPlay = null
		this.RTCPeerConnection = null
	}
}
export default Play

// 使用方式
// var play = new Play(stream_id,app,name,wsUrl)
// play.wsConnectPlay()